export default __webpack_public_path__ + "img/1654825198140.ff919236.jpg";